(() => {
  let busy = false;
  const config = () => JSON.parse(document.getElementById('wm-config').textContent);
  async function request(path, body) {
    const response = await fetch(config().root + path, {
      method: body === undefined ? 'GET' : 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      ...(body === undefined ? {} : {body: JSON.stringify(body)})
    });
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error(config().messages.unavailable);
    return result;
  }
  const matching = (cart, c) => cart.items.filter(item =>
    String(item.variant_id) === c.variant &&
    String(item.selling_plan_allocation?.selling_plan?.id) === c.sellingPlan &&
    item.properties?._ym_offer === 'hydration-monthly');
  async function start(quantity) {
    if (busy) return;
    const c = config();
    const buttons = document.querySelectorAll('.add-to-cart');
    const setMessage = text => document.querySelectorAll('.ymh-checkout-status').forEach(element => { element.textContent = text; });
    if (!c.enabled) { setMessage(c.messages.disabled); return; }
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 10) return;
    busy = true;
    buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    setMessage(c.messages.preparing);
    try {
      let cart = await request('cart.js');
      if (cart.currency !== 'USD') throw new Error(c.messages.currency);
      const activeCodes = (cart.discount_codes || []).map(code => code.code).filter(Boolean);
      const codes = activeCodes.filter(code => code.toUpperCase() !== c.discount.toUpperCase());
      if (codes.length !== activeCodes.length) {
        cart = await request('cart/update.js', {discount: codes.join(',')});
      }
      let lines = matching(cart, c);
      if (lines.length > 1) throw new Error(c.messages.reviewCart);
      const properties = {...(lines[0]?.properties || {}), _ym_offer: 'hydration-monthly'};
      delete properties['Your savings'];
      if (lines.length && (lines[0].quantity !== quantity || 'Your savings' in lines[0].properties)) {
        cart = await request('cart/change.js', {id: lines[0].key, quantity, properties});
        lines = matching(cart, c);
      } else if (!lines.length) {
        const added = await request('cart/add.js', {items: [{
          id: c.variant, quantity, selling_plan: c.sellingPlan, properties
        }]});
        lines = matching(added, c);
      }
      if (cart.currency !== 'USD' || lines.length !== 1 ||
          lines[0].quantity !== quantity || lines[0].final_line_price !== 4499 * quantity ||
          lines[0].original_line_price !== 4499 * quantity ||
          lines[0].selling_plan_allocation?.price !== 4499) {
        throw new Error(c.messages.price);
      }
      window.location.assign(c.root + 'checkout');
    } catch (error) {
      setMessage(error.message || c.messages.unavailable);
    } finally {
      busy = false;
      buttons.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); });
    }
  }
  return {start};
})();

(() => {
  const galleryState = new WeakMap();
  const imageDialog = document.querySelector('.image-dialog');
  function initialize(root = document) {
    root.querySelectorAll('.gallery').forEach(gallery => {
      if (galleryState.has(gallery)) return;
      const thumbs = [...gallery.querySelectorAll('.thumbs button')];
      galleryState.set(gallery, {index: 0, thumbs});
    });

  }
  function show(gallery, requested) {
    const state = galleryState.get(gallery);
    if (!state?.thumbs.length) return;
    state.index = (requested + state.thumbs.length) % state.thumbs.length;
    const selected = state.thumbs[state.index];
    const main = gallery.querySelector('.gallery-main');
    main.src = selected.dataset.full;
    main.alt = selected.dataset.alt;
    gallery.querySelector('.gallery-count').textContent = `${state.index + 1} / ${state.thumbs.length}`;
    state.thumbs.forEach((thumb, index) => thumb.setAttribute('aria-pressed', String(index === state.index)));
    const strip = gallery.querySelector('.thumbs');
    strip.scrollTo({left: Math.max(0, selected.offsetLeft - strip.offsetLeft), behavior: 'smooth'});
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('button,a');
    if (!target) return;
    const gallery = target.closest('.gallery');
    if (gallery) {
      const state = galleryState.get(gallery);
      if (target.matches('.thumbs button')) show(gallery, Number(target.dataset.index));
      if (target.matches('.prev,.next')) show(gallery, state.index + (target.matches('.prev') ? -1 : 1));
      if (target.matches('.thumb-prev,.thumb-next')) {
        const strip = gallery.querySelector('.thumbs');
        strip.scrollBy({left: strip.clientWidth * .8 * (target.matches('.thumb-prev') ? -1 : 1), behavior:'smooth'});
      }
      if (target.matches('.zoom-image')) {
        const main = gallery.querySelector('.gallery-main');
        const zoom = imageDialog.querySelector('img'); zoom.src = main.src; zoom.alt = main.alt;
        imageDialog.showModal();
      }
    }
    if (target.matches('.cart-toggle')) window.location.assign(JSON.parse(document.getElementById('wm-config').textContent).root + 'cart');
    if (target.matches('.image-dialog .close')) imageDialog.close();
    if (target.matches('.menu')) {
      const nav = target.closest('.nav').querySelector('.navlinks');
      const open = nav.classList.toggle('open'); target.setAttribute('aria-expanded', String(open));
    }
    if (target.matches('.navlinks a')) {
      const nav = target.closest('.nav'); nav.querySelector('.navlinks').classList.remove('open');
      nav.querySelector('.menu')?.setAttribute('aria-expanded','false');
    }
  });
  let touch = null;
  document.addEventListener('touchstart', event => {
    const gallery = event.target.closest('.gallery');
    if (gallery) touch = {gallery, x: event.changedTouches[0].clientX};
  }, {passive:true});
  document.addEventListener('touchend', event => {
    if (!touch) return;
    const distance = event.changedTouches[0].clientX - touch.x;
    if (Math.abs(distance)>50) show(touch.gallery, galleryState.get(touch.gallery).index + (distance<0 ? 1 : -1));
    touch=null;
  }, {passive:true});
  imageDialog?.addEventListener('click', event => { if (event.target===imageDialog) imageDialog.close(); });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:block:select', event => {
    const target = event.target.closest('[data-ymh-block]') || event.target;
    const gallery = target.closest('.gallery');
    if (gallery && target.dataset.index !== undefined) show(gallery, Number(target.dataset.index));
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('.wm-quantities input')) return;
    const bags = event.target.value;
    document.querySelectorAll('.wm-offer').forEach(offer => {
      offer.querySelectorAll('.wm-quantities input').forEach(input => { input.checked = input.value === bags; });
      offer.querySelectorAll('[data-wm-price]').forEach(node => { node.hidden = node.dataset.wmPrice !== bags; });
      offer.querySelectorAll('[data-wm-purchase]').forEach(node => { node.hidden = node.dataset.wmPurchase !== bags; });
    });
  });
  initialize();
})();
